export enum ModuleView {
    Table = "table",
    Chart = "chart",
    Dual = "dual",
    Graph = "graph"
}

export enum NumericType
{
    Currency = 0,
    Number = 1,
    Percent = 2,
    Time = 3
}

export enum TimeType
{
    None = 0,
    Second = 1,
    Minute = 2,
    Hour = 3,
    Time = 4
}

export enum ErrorList
{
    NoError = 0,
    NoMetric = 1,
    DateRangeTooWideIntraday = 2,
}

export interface PerformanceModuleData {
    columnDefs: PerformanceModuleDataColumn[];
    rows: PerformanceModuleDataRow[];
    Error: ErrorList;
}

export interface PerformanceModuleDataColumn {
    name: string;
    field: string;
    displayName: string;
    customName: string;
    metricID: number;
    width: string;
    minWidth: string;
    type: string;
    enablePinning: boolean;
    enableHiding: boolean;
    footerCellTemplate: string;
    totalValue: number;
    total: string;
    avgValue: number;
    avg: string;
    numericType: NumericType;
    timeType?: TimeType;
}

export interface PerformanceModuleDataRow {
    group: ModuleDataGroupItem;
    locationGroup: ModuleDataGroupItem;
    metricTypes: (NumericType | null)[];
    metricTypeNames: string[];
    metricTimeTypes: (TimeType | null)[];
    metricData: MetricData[];
    attributeIDs: number[];
    attributeValue: string[];
}

export interface ModuleDataGroupItem {
    groupID: number;
    groupLevel: number;
    groupName: string;
    groupHierarchy: string;
    groupType: string;
    teamUUID: string;
    agentUUID: string;
}

export interface MetricData {
    MetricID: number;
    MetricValue: number | null;
    MetricDisplayValue: string;
    Value: number;
    AlertThreshold: number;
    Bound: number;
    Direction: number;
    POPercent: number;
    ThresholdPercent: number; // For future coloring
    HasPO: boolean; // If they have a PO
    NumeratorValue: number;
    DenominatorValue: number;
    UseDenominator: boolean;
    isMax: boolean;
    formatCurrentStateTime: boolean;
    objectiveData: ObjectiveData;
    MetricType: NumericType;
    hasThreshold: boolean;
}

export interface ObjectiveData {
    poDetails: ObjectiveDetail[];
    poColors: ObjectiveColor[];
    poValueColor: string;
    poValueRgbaColor: string;
}

export interface ObjectiveDetail {
    // Data Transfer Object (Business Object)
    _obj: ObjectiveDetailDTO;
    MongoLog: any;
    _PreviousDTO: ObjectiveDetailDTO;

    // Status variables
    _Dirty: boolean;
    _Add: boolean;
}

export interface ObjectiveDetailDTO {
    ObjectiveDetailID: number;
    CompanyID: number;
    ObjectiveID: number;
    Value: number;
    DWM: number;
    CreatedByID: number;
    LastModifiedByID: number;
    DateModified: Date;
}

export interface ObjectiveColor {
    // Data Transfer Object (Business Object)
    _obj: ObjectiveColorDTO;

    // Status variables
    _Dirty: boolean;
    _Add: boolean;
}

export interface ObjectiveColorDTO {
    ObjectiveColorID: number;
    CompanyID: number;
    ObjectivePaletteID: number;
    ColorLabel: string;
    HexColor: string;
    RgbaColor: string;
    Level: number;
    CreatedByID: number;
    LastModifiedByID: number;
    DateModified: Date;
}
